module.exports = __webpack_public_path__ + "media/components/guide-page/static/icon-wetsuit--winter-3b15e215bbd41d5a37e7f708a0ac9f30.svg";